import { notification } from "antd";

const catching = (error: any) => {
  const status = error?.response?.status;
  const message = error?.response?.data?.message;
  // notification.config()
  // code: "NM:000001"
  switch (status) {
    case 400:
      notification.error({
        message: message || "لطفا فیلد ها را به درستی وارد کنید",
      });
      break;
    case 401:
      notification.error({
        message: message || "لطفا ابتدا وارد شوید",
      });
      break;
    // case 403:
    //   break;
    case 404:
      notification.error({
        message: message || "درخواست مورد نظر یافت نشد",
      });
      break;
    case 500:
      notification.error({
        message: "در سرور خطایی رخ داد",
        description: message,
      });
      break;
    default:
      notification.error({
        message: message,
      });
      break;
  }
};
export default catching;
